/*
 * <xt-delivery-estimate>: "Estimated delivery: 29 Sep - 30 Sep" on the product page (feedback 23/09).
 * Business days only (Mon-Fri). Orders after the cutoff hour start counting the next business day.
 * Range = today + processing days + transit days for the visitor's country zone.
 */
if (!customElements.get('xt-delivery-estimate')) {
  class XtDeliveryEstimate extends HTMLElement {
    connectedCallback() {
      const d = this.dataset;
      const num = (value, fallback) => {
        const n = parseInt(value, 10);
        return Number.isFinite(n) ? n : fallback;
      };
      const homeCountries = (d.homeCountries || '')
        .split(',')
        .map((code) => code.trim().toUpperCase())
        .filter(Boolean);
      const isHome = homeCountries.includes((d.country || '').toUpperCase());

      const processingMin = num(d.processingMin, 1);
      const processingMax = num(d.processingMax, 2);
      const transitMin = isHome ? num(d.homeMin, 3) : num(d.otherMin, 5);
      const transitMax = isHome ? num(d.homeMax, 3) : num(d.otherMax, 7);

      const start = new Date();
      if (start.getHours() >= num(d.cutoff, 14)) start.setDate(start.getDate() + 1);

      const from = this.addBusinessDays(start, processingMin + transitMin);
      const to = this.addBusinessDays(start, Math.max(processingMax + transitMax, processingMin + transitMin));

      let format;
      try {
        format = new Intl.DateTimeFormat(d.locale || undefined, { weekday: 'short', day: 'numeric', month: 'short' });
      } catch (error) {
        format = new Intl.DateTimeFormat(undefined, { weekday: 'short', day: 'numeric', month: 'short' });
      }

      const range = this.querySelector('[data-delivery-range]');
      if (!range) return;
      range.textContent =
        from.toDateString() === to.toDateString() ? format.format(from) : `${format.format(from)} - ${format.format(to)}`;
      this.hidden = false;
    }

    addBusinessDays(date, days) {
      const result = new Date(date);
      // a start on a weekend counts from Monday
      while (result.getDay() === 0 || result.getDay() === 6) result.setDate(result.getDate() + 1);
      let added = 0;
      while (added < days) {
        result.setDate(result.getDate() + 1);
        if (result.getDay() !== 0 && result.getDay() !== 6) added += 1;
      }
      return result;
    }
  }

  customElements.define('xt-delivery-estimate', XtDeliveryEstimate);
}
